import React, { useRef, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import * as auth from "./authRedux";
import { getUserByToken } from "./authCrud";
import { baseUrl } from "../../../../services/config";

function AuthInit(props) {
  const dispatch = useDispatch();
  const [showSplashScreen, setShowSplashScreen] = useState(true);

  const authToken = localStorage.getItem("userToken");

  useEffect(() => {
    try {
      const storedUser = JSON.parse(localStorage.getItem("userDetails"));

      if (authToken && storedUser) {
        dispatch({
          type: "ADD_USER",
          payload: {
            isAuthenticated: true,
            authtoken: authToken,
            user: storedUser,
          },
        });

        props.fulfillUser(storedUser);
      } else {
        props.logout();
      }
    } catch (error) {
      console.error("Unable to restore stored user:", error);
      props.logout();
    } finally {
      setShowSplashScreen(false);
    }
  }, []);

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>;
}

export default connect(null, auth.actions)(AuthInit);
